module.exports = __webpack_public_path__ + "img/116039.2dec7c8b.png";